import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["aria-describedby"]
const _hoisted_3 = { class: "govuk-fieldset__legend govuk-fieldset__legend--l" }
const _hoisted_4 = { class: "govuk-fieldset__heading" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, "Error:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "govuk-radios" }
const _hoisted_10 = ["checked", "id", "name", "value"]
const _hoisted_11 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.fieldGroupId,
    class: _normalizeClass(_ctx.fieldGroupClassList)
  }, [
    _createElementVNode("fieldset", {
      class: "govuk-fieldset",
      "aria-describedby": _ctx.inputDescribedBy
    }, [
      _createElementVNode("legend", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.fieldset.text), 1)
      ]),
      (_ctx.field.hint)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: _ctx.hintId,
            class: "govuk-hint"
          }, _toDisplayString(_ctx.field.hint), 9, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.field.errors)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            id: _ctx.errorId,
            class: "govuk-error-message"
          }, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.errors, (error, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                _createTextVNode(_toDisplayString(error.error), 1),
                _hoisted_8
              ]))
            }), 128))
          ], 8, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.options, (option, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "govuk-radios__item"
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "govuk-radios__input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
              checked: option.default,
              id: _ctx.getOptionId(option.name),
              name: _ctx.field.name,
              type: "radio",
              value: option.value
            }, null, 8, _hoisted_10), [
              [_vModelRadio, _ctx.inputValue]
            ]),
            _createElementVNode("label", {
              class: "govuk-label govuk-radios__label",
              for: _ctx.getOptionId(option.name)
            }, _toDisplayString(option.label), 9, _hoisted_11)
          ]))
        }), 128))
      ])
    ], 8, _hoisted_2)
  ], 10, _hoisted_1))
}